import {
  Header,
  HeaderItem,
  Sidebar,
  SidebarFooter,
  SidebarItem,
  SidebarPageWrapper,
} from '@trueprodigy/components';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import ImmutablePropTypes from 'react-immutable-proptypes';
import styled from 'styled-components';

import * as globalActions from '@actions/global';
import HeaderZendeskWidget from '@components/HeaderZendeskWidget/HeaderZendeskWidget';
import rocketIcon from '@components/Sidebar/assets/rocket-icon.png';
import SidebarAccountSettingsWidget from '@components/Sidebar/SidebarAccountSettingsWidget';
import SidebarRdsNameWidget from '@components/Sidebar/SidebarRdsNameWidget';
import SidebarCaseSettingWidget from '@components/Sidebar/SidebarCaseSettingWidget';
import HeaderWrapper from '@components/HeaderWrapper';
import { eventDataSelector } from '@modules/events/selectors/event';
import {
  isSidebarVisibleSelector,
  userDataSelector,
  userStatusSelector,
  userRightsSelector,
} from '@selectors/global';
import ability, { defineRules } from '@config/permissions/ability';
import { hasRight } from '@utils';
import { RIGHTS } from '@constants';

import eventsLogo from '../assets/events-app-logo.png';
import generateIcon from '../assets/generate-icon.png';
import screenIcon from '../assets/print-screen-icon.png';
import versionIcon from '../assets/PA_Version.png';

const pageTitle = path => {
  if (path === '/events/search') {
    return 'Event Search';
  } else if (path === '/events/create' || path.indexOf('/events/edit/') > -1) {
    return 'Event Record';
  } else if (
    path === '/events/form' ||
    path === '/events/form/create' ||
    path.indexOf('/events/form/edit/') > -1
  ) {
    return 'Event Form';
  } else if (path.indexOf('/events/roles') > -1) {
    return 'Event Role';
  }

  return 'Event';
};

const PageWrapper = ({
  children,
  current,
  history: {
    location: { pathname },
  },
  isSidebarVisible,
  toggleSidebar,
  userData,
  userStatus,
  userRights,
}) => {
  const isReadOnly = userStatus.get('readOnly');
  useEffect(() => {
    if (userRights && userRights.toJS() && userRights.toJS().length) {
      const rules = defineRules(userRights.toJS());
      ability.update(rules);
    }
  }, [userRights]);

  useEffect(() => {
    const isiPad = navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints;
    if (isSidebarVisible && isiPad) {
      toggleSidebar();
    }
  }, [location.pathname]);
  return (
    <div>
      <Sidebar
        isSidebarVisible={isSidebarVisible}
        logo={eventsLogo}
        sidebarFooter={
          <SidebarFooter>
            <SidebarRdsNameWidget />
            <SidebarCaseSettingWidget />
            <SidebarAccountSettingsWidget />
          </SidebarFooter>
        }
      >
        <SidebarItem icon={rocketIcon} link="/" title="Prodigy App Launcher" />
        <SidebarItem link="/events/search" title="Prodigy Events Search" />
        {current.eventID && (
          <SidebarItem
            link={`/events/edit/${current.eventID}`}
            title="Prodigy Event Record"
          />
        )}
        {hasRight(userData.get('userrights').toJS(), RIGHTS.EVENTS.EVENT) &&
          !isReadOnly && (
            <SidebarItem nested title="App Functions">
              <SidebarItem link="/events/create" title="Create New Event" />
              <SidebarItem
                link="/events/quick-entry"
                title="Event Quick Entry"
              />
            </SidebarItem>
          )}
        {hasRight(
          userData.get('userrights').toJS(),
          RIGHTS.EVENTS.APPSETTINGS,
        ) &&
          !isReadOnly && (
            <SidebarItem nested title="App Settings">
              <SidebarItem link="/events/form" title="Prodigy Event Form" />
              <SidebarItem link="/events/roles" title="Prodigy Role Access" />
              <SidebarItem
                link="/events/codefile"
                title="Code File Maintenance"
              />
            </SidebarItem>
          )}
      </Sidebar>
      <PageWrapper.ContentWrapper>
        <SidebarPageWrapper isSidebarVisible={isSidebarVisible}>
          <HeaderWrapper>
            <Header title={pageTitle(pathname)} toggleSidebar={toggleSidebar}>
              {hasRight(
                userData.get('userrights').toJS(),
                RIGHTS.EVENTS.EVENT,
              ) &&
                !isReadOnly && (
                  <HeaderItem
                    icon={generateIcon}
                    link="/events/create"
                    title="Create Event"
                  />
                )}
              <HeaderItem
                icon={versionIcon}
                title="Smart List"
                link="/events/smart-lists?module=Prodigy%20Events"
              />
              <HeaderItem
                icon={screenIcon}
                title="Print Screen"
                onClick={() => window.print()}
              />
              <HeaderZendeskWidget />
            </Header>
          </HeaderWrapper>

          <div>{children}</div>
        </SidebarPageWrapper>
      </PageWrapper.ContentWrapper>
    </div>
  );
};

PageWrapper.propTypes = {
  children: PropTypes.node,
  current: PropTypes.object,
  history: PropTypes.object,
  isSidebarVisible: PropTypes.bool,
  toggleSidebar: PropTypes.func.isRequired,
  userData: ImmutablePropTypes.map,
  userStatus: PropTypes.any,
  userRights: PropTypes.any,
};

PageWrapper.ContentWrapper = styled.div`
  > div {
    margin-top: -67px;
    min-height: 100vh;
    background-color: #f2f4f6;
  }
`;

const mapStateToProps = createStructuredSelector({
  current: eventDataSelector,
  userData: userDataSelector,
  isSidebarVisible: isSidebarVisibleSelector,
  userStatus: userStatusSelector,
  userRights: userRightsSelector,
});

const mapDispatchToProps = {
  toggleSidebar: globalActions.toggleSidebar,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PageWrapper);
